import Modal from "./modal";

function bindQuoteForm(form, success) {
  if (!form || !success) return;

  const errorBox = form.querySelector(".quote-form__error");
  const submitBtn = form.querySelector('button[type="submit"]');

  const showError = (msg) => {
    if (!errorBox) return;
    errorBox.textContent = msg;
    errorBox.hidden = false;
  };

  const hideError = () => {
    if (!errorBox) return;
    errorBox.hidden = true;
  };

  form.addEventListener("submit", (e) => {
    e.preventDefault();

    const name = form.name;
    const email = form.email;
    const message = form.message;
    let ok = true;

    [name, email, message].forEach((field) => {
      if (!field.value.trim()) {
        field.style.borderColor = "var(--primary-color)";
        ok = false;
      } else {
        field.style.borderColor = "";
      }
    });

    if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value)) {
      email.style.borderColor = "var(--primary-color)";
      ok = false;
    }

    if (!ok) return;

    hideError();
    if (submitBtn) submitBtn.disabled = true;

    fetch(form.action, {
      method: "POST",
      body: new FormData(form),
      headers: { Accept: "application/json" },
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok: reqOk, data }) => {
        if (!reqOk || !data.success) {
          throw new Error(data.message || "Something went wrong. Please try again.");
        }
        form.classList.add("is-hidden");
        success.hidden = false;
      })
      .catch((err) => {
        showError(err.message || "Something went wrong. Please try again.");
      })
      .finally(() => {
        if (submitBtn) submitBtn.disabled = false;
      });
  });
}

function resetQuoteModalForm() {
  const form = document.getElementById("quoteFormModal");
  const success = document.getElementById("quoteFormSuccessModal");

  if (!form) return;

  form.reset();
  form.classList.remove("is-hidden");
  form.querySelectorAll("input, textarea, select").forEach((field) => {
    field.style.borderColor = "";
  });

  const errorBox = form.querySelector(".quote-form__error");
  if (errorBox) errorBox.hidden = true;

  if (success) success.hidden = true;
}

export default function quoteFormPopup() {
  Modal("#quoteModal", "#quoteBackdrop", ".js-open-quote", resetQuoteModalForm);

  bindQuoteForm(
    document.getElementById("quoteFormModal"),
    document.getElementById("quoteFormSuccessModal")
  );

  bindQuoteForm(
    document.getElementById("quoteForm"),
    document.getElementById("quoteFormSuccess")
  );
}
